/* src/config/settings.js */

import { ajax } from 'rxjs/ajax';

export const adminDomain = process.env.NODE_ENV !== 'development' ? 'http://localhost:8080' : 'https://nimbus2.herokuapp.com';
export const domain = 'https://nimbus1.herokuapp.com';
export const url = `${domain}/api/v2`;
export const adminURL = adminDomain;
export const mapboxKey = 'pk.eyJ1IjoibmltYnVzLWRldiIsImEiOiJjamp5bHFjaTcxZTFmM3ByejZ1bHZ3YjgxIn0.Ere0Dg-Y6hBTTDBQ8InqhQ';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  token: 'D17057FD9E92D14CD13D12A65D86E77B6AC0EA1AEA93B0D612C50AF8AAB865DA',
};

const authHeader = token => ({
  ...headers,
  Authorization: `Bearer ${token}`,
});

export const request = (query, token = '') => ajax({
  method: 'POST',
  url: adminURL,
  body: JSON.stringify(query),
  headers: token ? authHeader(token) : headers,
});

export default { url, headers, authHeader, adminURL, mapboxKey };



// WEBPACK FOOTER //
// ./src/config/settings.js